import React from 'react'
import _ from 'lodash'
import { navigate } from 'gatsby'
import styled from 'styled-components'
import { withTranslation } from 'react-i18next'
import { globalHistory as history } from '@reach/router'
import classnames from 'classnames'
import { color } from '../utils/typography'

export default styled(withTranslation()(class extends React.Component {
  state = {
    language: this.props.i18n.language,
  }

  handleChange = ev => {
    const { i18n } = this.props
    const targetLang = ev.target.value

    this.setState({ language: targetLang })
    i18n.changeLanguage(targetLang)

    const currentRoute = history.location.pathname
    const currentParts = currentRoute.split('/')
    const currentLang = _.lowerCase(currentParts[1])

    if (currentLang === targetLang) {
      return
    } else if (~i18n.options.whitelist.indexOf(currentLang)) {
      currentParts[1] = targetLang
      navigate(currentParts.join('/'))
    } else {
      const targetParts = currentParts.slice()
      targetParts.splice(1, 0, targetLang)
      navigate(targetParts.join('/'))
    }
  }

  render() {
    const { className } = this.props
    return (
      <select className={classnames([className, 'form-input'])}
        onChange={this.handleChange} value={this.state.language}>
        <option value='de'>Deutsch</option>
        <option value='en'>English</option>
      </select>
    )
  }
}))`
  &, &:hover, &:active, &:focus {
    width: auto;
    border: none;
    color: ${color.accent};
    cursor: pointer;
  }
`
